import React from 'react';
// import NexusCallout from './NexusCallout';
import RequestMissingBirthdaysCallout from './RequestMissingBirthdaysCallout';
import { useDispatch, useSelector } from 'react-redux';
import { setUserMetadataFlag } from '@repo/redux/actions/user';
import UpdateLinkedInIntegrationCallout from './UpdateLinkedInIntegrationCallout';
import { useAuthContext } from '@repo/hooks';
import { selectUserHasFlag } from '@repo/redux/reducers/user/metadata';

export default function UserCallouts() {
  const dispatch = useDispatch();
  const { getEntitlementValue } = useAuthContext();
  // const nexusCalloutDismissed = useSelector(selectUserHasFlag('nexusCalloutDismissed'));
  const requestBirthdaysCalloutDismissed = useSelector(
    selectUserHasFlag('requestBirthdaysCalloutDismissed'),
  );

  return (
    <>
      {/* {!nexusCalloutDismissed && (
        <NexusCallout
          dismissCallout={() => dispatch(setUserMetadataFlag('nexusCalloutDismissed', true))}
        />
      )} */}
      {!requestBirthdaysCalloutDismissed && (
        <RequestMissingBirthdaysCallout
          dismissCallout={() =>
            dispatch(setUserMetadataFlag('requestBirthdaysCalloutDismissed', true))
          }
        />
      )}
      {getEntitlementValue('linkedin.version') === 2 && <UpdateLinkedInIntegrationCallout />}
    </>
  );
}
